var _path, _rect, _path2, _rect2, _path3, _rect3, _path4, _rect4, _path5, _rect5, _path6, _rect6, _path7, _rect7, _rect8, _path8, _rect9, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllCategories(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 63,
    viewBox: "0 0 76 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.6088 2.14353C43.4871 -1.8092 29.4706 -0.307497 21.7248 6.75054C16.2556 11.734 20.4886 13.1544 24.2173 22.2734C26.916 28.8734 0.167969 27.965 0.167969 39.8909C0.167969 53.6781 19.5407 51.0647 26.7298 52.6428C37.7214 55.0559 47.3103 64.0824 59.0542 62.8925C69.2781 61.8564 73.1758 53.8488 74.5976 44.6688C77.2463 27.566 70.7408 8.834 53.6088 2.14353Z",
    fill: "url(#paint0_linear_3783_151061)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.668,
    y: 45,
    width: 14,
    height: 14,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.668 45L24.468 45C24.5784 45 24.668 45.0895 24.668 45.2L24.668 58.8C24.668 58.9105 24.5784 59 24.468 59L10.868 59C10.7575 59 10.668 58.9105 10.668 58.8L10.668 45.2C10.668 45.0895 10.7575 45 10.868 45L13.668 45",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 50.668,
    y: 45,
    width: 14,
    height: 14,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.668 59H50.868C50.7575 59 50.668 58.9105 50.668 58.8V45.2C50.668 45.0895 50.7575 45 50.868 45H64.468C64.5784 45 64.668 45.0895 64.668 45.2V58.8C64.668 58.9105 64.5784 59 64.468 59H61.668",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30.668,
    y: 45,
    width: 14,
    height: 14,
    fill: "#DDC2FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.668 55.5L44.668 58.8C44.668 58.9105 44.5784 59 44.468 59L30.868 59C30.7575 59 30.668 58.9105 30.668 58.8L30.668 45.2C30.668 45.0895 30.7575 45 30.868 45L44.468 45C44.5784 45 44.668 45.0895 44.668 45.2L44.668 50.5",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 50.668,
    y: 25,
    width: 14,
    height: 14,
    fill: "#DDC2FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.668 29L50.668 25.2C50.668 25.0895 50.7575 25 50.868 25L64.468 25C64.5784 25 64.668 25.0895 64.668 25.2L64.668 38.8C64.668 38.9105 64.5784 39 64.468 39L50.868 39C50.7575 39 50.668 38.9105 50.668 38.8L50.668 36",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 30.668,
    y: 5,
    width: 14,
    height: 14,
    fill: "#DDC2FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.668 19H30.868C30.7575 19 30.668 18.9105 30.668 18.8V5.2C30.668 5.08954 30.7575 5 30.868 5H44.468C44.5784 5 44.668 5.08954 44.668 5.2V18.8C44.668 18.9105 44.5784 19 44.468 19H41.668",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 10.668,
    y: 25,
    width: 14,
    height: 14,
    fill: "#DDC2FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.668 35.5L24.668 38.8C24.668 38.9105 24.5784 39 24.468 39L10.868 39C10.7575 39 10.668 38.9105 10.668 38.8L10.668 25.2C10.668 25.0895 10.7575 25 10.868 25L24.468 25C24.5784 25 24.668 25.0895 24.668 25.2L24.668 30.5",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 30.668,
    y: 25,
    width: 14,
    height: 14,
    fill: "white",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 10.668,
    y: 5,
    width: 14,
    height: 14,
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.668 9L10.668 5.2C10.668 5.08954 10.7575 5 10.868 5L24.468 5C24.5784 5 24.668 5.08954 24.668 5.2L24.668 18.8C24.668 18.9105 24.5784 19 24.468 19L10.868 19C10.7575 19 10.668 18.9105 10.668 18.8L10.668 16",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 50.668,
    y: 5,
    width: 14,
    height: 14,
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.668 5L64.468 5C64.5784 5 64.668 5.08954 64.668 5.2L64.668 18.8C64.668 18.9105 64.5784 19 64.468 19L50.868 19C50.7575 19 50.668 18.9105 50.668 18.8L50.668 5.2C50.668 5.08954 50.7575 5 50.868 5L53.668 5",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3783_151061",
    x1: 16.3933,
    y1: 61.3799,
    x2: 64.9076,
    y2: 12.7738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8D7FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllCategories);
export default __webpack_public_path__ + "static/media/allCategories.78accead299bb68c5a560c82ccff14c2.svg";
export { ForwardRef as ReactComponent };